const steps = [
  {
    n: 1,
    title: "Schrijf in via de site",
    text: "Kies een workshop, vul in wie komt. Bevestiging en locatie krijg je direct in je mailbox.",
  },
  {
    n: 2,
    title: "Kom zaterdag langs",
    text: "Drie uur Arduino en coderen. Laptop meebrengen, wij zorgen voor de rest. Pauze met drankje en snack.",
  },
  {
    n: 3,
    title: "Neem je creatie mee",
    text: "Geen leeg gevoel na een les. Elk kind gaat naar huis met een werkend project én een kaartje met 3 thuisprojecten.",
  },
];

export function Steps() {
  return (
    <section id="hoe">
      <div className="container">
        <div className="section-head">
          <span className="section-tag">Hoe werkt het?</span>
          <h2>Inschrijven en komen — simpel als dat</h2>
        </div>
        <div className="steps">
          {steps.map((s) => (
            <div className="step" key={s.n}>
              <div className="step-num">{s.n}</div>
              <h4>{s.title}</h4>
              <p>{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
